// features/employee/fund/schemas/EmployeeFundSchemas.js
import { CRITERIA_BASIS, TIME_UNIT, toOptions } from "features/fund/schemas/FundSchemas";

export { CRITERIA_BASIS, TIME_UNIT, toOptions };

// สถานะกองทุน (ของพนักงานรายบุคคล)
export const MEMBERSHIP_STATUS = [
    { value: "ACTIVE", name: "เป็นสมาชิกกองทุน", nameEn: "Active member" },
    { value: "INACTIVE", name: "ลาออกจากกองทุน", nameEn: "Resigned" },
];

// วิธีหักเงินพนักงาน / วิธีสมทบของบริษัท
export const CONTRIBUTION_METHOD = [
    { value: "PERCENTAGE", name: "เปอร์เซ็นต์ (%)", nameEn: "Percentage (%)" },
    { value: "FIXED_AMOUNT", name: "จำนวนเงินคงที่", nameEn: "Fixed amount" },
];

export const MAX_BENEFICIARIES = 4;

export const emptyBeneficiary = () => ({
    fullName: undefined,
    nationalId: undefined,
    relationship: undefined,
    sharePercent: undefined,
    address: undefined,
});

export const emptyEligibilityCondition = (conditionType) => ({
    conditionType,
    duration: undefined,
    durationUnit: "YEAR",
    effectiveStartDate: undefined,
});

export const DEFAULT_MEMBERSHIP_VALUES = {
    fundId: undefined,
    contractStartDate: undefined,
    contractEndDate: undefined,
    statusFlag: "ACTIVE",
    membershipEligibility: emptyEligibilityCondition("YEARS_OF_SERVICE"),
    contributionEligibility: emptyEligibilityCondition("MEMBERSHIP_AGE"),
    employeeContribution: { method: "PERCENTAGE", rate: undefined },
    companyContribution: { method: "PERCENTAGE", rate: undefined },
    beneficiaries: [],
};

// label for the duration input itself — mirrors conditionType ("อายุงาน" input under an "อายุงาน" radio choice)
export const getConditionDurationLabel = (conditionType, lang = "th") => {
    if (conditionType === "MEMBERSHIP_AGE") {
        return lang === "en" ? "Membership age" : "อายุสมาชิก";
    }
    return lang === "en" ? "Years of service" : "อายุงาน";
};
